import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { MyHttpClient } from '../http-client';

export interface HostVehicle {
  rcId: string;
  number: string;
  status: string;
  active: boolean;
  info: {
    vehicleModel?: string;
    modeId?: string;
    manufacturer?: string;
    model?: string;
    displayName?: string;
    color?: string;
    [key: string]: any;
  };
}

export interface HostSearchResult {
  _id: string;
  mobile?: string;
  name?: string;
  email?: string;
}

const BASE = process.env.SERVER;

@Injectable()
export class HostService {
  constructor(private http: MyHttpClient) {}

  searchByPhone(phone: string): Observable<any> {
    return this.http.get<any>(`${BASE}/api/hosts/search?phone=${encodeURIComponent(phone)}`);
  }

  searchByVehicleNumber(vehicleNumber: string): Observable<any> {
    return this.http.get<any>(`${BASE}/api/hosts/search?vehicleNumber=${encodeURIComponent(vehicleNumber)}`);
  }

  getHostVehicles(hostId: string): Observable<HostVehicle[]> {
    return this.http.get<any>(`${BASE}/api/hosts/${encodeURIComponent(hostId)}/vehicles`)
      .map((res: any) => {
        return Array.isArray(res && res.vehicles) ? res.vehicles : [];
      });
  }

  approveVehicle(hostId: string, vehicleId: string, payload: {
    vehicleNumber: string;
    vehicleModel: { id: string; modeId?: string };
    status: string;
    actorId?: string;
  }): Observable<any> {
    return this.http.put(`${BASE}/api/hosts/${encodeURIComponent(hostId)}/vehicle/${encodeURIComponent(vehicleId)}`, payload);
  }

  rejectVehicle(hostId: string, vehicleId: string, payload: {
    vehicleNumber: string;
    status: string;
    remarks: string;
    actorId?: string;
  }): Observable<any> {
    return this.http.put(`${BASE}/api/hosts/${encodeURIComponent(hostId)}/vehicle/${encodeURIComponent(vehicleId)}`, payload);
  }

  uploadRcImage(vehicleId: string, imageData: string): Observable<any> {
    return this.http.post(`${BASE}/api/hosts/rc/${encodeURIComponent(vehicleId)}/image`, { data: imageData });
  }

  getVehicleModels(modeId?: string): Observable<any[]> {
    const parts: string[] = ['active=false', 'limit=200'];
    if (modeId) parts.push(`modeId=${encodeURIComponent(modeId)}`);
    return this.http.get<any>(`${BASE}/api/get/vehicleModel?${parts.join('&')}`)
      .map((res: any) => (res && Array.isArray(res.items)) ? res.items : []);
  }

  getHostConfig(): Observable<{ validPoolModeIds: string[] }> {
    return this.http.get<any>(`${BASE}/api/hosts/config`)
      .map((res: any) => ({
        validPoolModeIds: Array.isArray(res && res.validPoolModeIds) ? res.validPoolModeIds : [],
      }));
  }

  getModes(userId: string): Observable<any[]> {
    return this.http.get<any>(`${BASE}/api/captain/modes/${encodeURIComponent(userId)}`)
      .map((res: any) => {
        const data = res && res['data'] && res['data']['modes'] && res['data']['modes']['data'];
        return Array.isArray(data) ? data.map((m: any) => ({ _id: m._id, mode: m.mode || m.name || '' })) : [];
      });
  }
}
